// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2pOwM","top":"top___31jB-","bottom":"bottom___cb3cb","name":"name___1ZKve","content":"content___21qUm"};